import type { FC } from "react";

import { Text, Code, Paragraph } from "@hightouch/htui";
import { Link } from "src/router";
import ReactMarkdown from "react-markdown";

import type { MarkdownProps } from "./types";

export const MarkdownInner: FC<Readonly<MarkdownProps>> = ({
  disableParagraphs = false,
  useParagraphMargins = false,
  underlineLinks = false,
  children,
}) => {
  return (
    <ReactMarkdown
      components={{
        p: ({ children }) => {
          if (disableParagraphs) {
            return <>{children}</>;
          }
          return (
            <Paragraph my={useParagraphMargins ? 4 : 0}>{children}</Paragraph>
          );
        },
        strong: ({ children }) => {
          return <Text fontWeight="semibold">{children}</Text>;
        },
        a: ({ href, children }) => (
          <Link
            href={href ?? "#"}
            color="var(--chakra-colors-link-default)"
            fontSize="inherit"
            isExternal={!href?.startsWith("/")}
            sx={underlineLinks ? { textDecoration: "underline" } : undefined}
          >
            {children}
          </Link>
        ),
        code: ({ children }) => {
          return <Code>{children}</Code>;
        },
      }}
    >
      {children}
    </ReactMarkdown>
  );
};

export default MarkdownInner;
